import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Детски чаршафи с ластик от 100% памук | Размери по поръчка | GoToBed',
  description:
    'Детски чаршафи с ластик от 100% памук за бебешко и детско легло. Ранфорс и памучен сатен, размери 60/120, 70/140, 82/190, 90/200. Поръчайте от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Детски чаршафи с ластик от 100% памук
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Детски чаршафи с ластик от 100% памук за бебешко и детско легло
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Детските чаршафи с ластик от 100% памук са практично решение за бебешко и детско легло и
          се предлагат в голям избор от размери за различни детски матраци. Благодарение на ластика
          по целия ръб чаршафът прилепва плътно към матрака и остава стабилен по време на сън. В
          тази категория ще откриете детски чаршафи с ластик от 100% памук в едноцветни и шарени (с
          принт) десени, подходящи за бебешки и детски легла. Чаршафите се изработват по поръчка,
          което позволява да предложим голямо разнообразие от размери за различни матраци като
          60/120, 70/140, 82/190 и 90/200. Чаршафите се изработват от висококачествени памучни
          платове – ранфорс и памучен сатен.
        </Typography>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyDetskiCharshafiSLastik />;
}

function SeoBodyDetskiCharshafiSLastik() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Детски чаршафи с ластик за бебешко и детско легло – 100% памук */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Детски чаршафи с ластик за бебешко и детско легло – 100% памук
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Детските чаршафи с ластик са практично и удобно решение за бебешки и детски легла.
        Благодарение на ластика по целия ръб чаршафът прилепва плътно към матрака и остава стабилно
        на мястото си по време на сън.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В тази категория ще откриете детски чаршафи с ластик, изработени от 100% памук, които са
        меки, дишащи и подходящи за чувствителната детска кожа. Чаршафите са подходящи както за
        бебешки матраци, така и за детски легла и по-големи матраци.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В GoToBed предлагаме чаршафи от висококачествен памук – ранфорс и памучен сатен,
        сертифицирани по OEKO-TEX Standard 100 платове, което гарантира безопасност на текстила и
        липса на вредни вещества.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        Ако търсите конкретен вид плат, можете да разгледате и нашите:
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-charshafi-s-lastik/2/9/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски чаршафи с ластик ранфорс
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-charshafi-s-lastik/2/9/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски чаршафи с ластик памучен сатен
        </Typography>
      </Box>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Голям избор от размери детски чаршафи с ластик */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Голям избор от размери детски чаршафи с ластик
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Едно от основните предимства на нашите продукти е голямото разнообразие от размери, което
          позволява да намерите подходящ чаршаф с ластик за бебешко или детско легло.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Предлагаме детски чаршафи с ластик за матраци със следните размери:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '60/110/20',
            '60/120/20',
            '60/130/20',
            '60/140/20',
            '65/110/20',
            '65/120/20',
            '65/130/20',
            '65/140/20',
            '65/150/20',
            '65/160/20',
            '70/110/20',
            '70/120/20',
            '70/130/20',
            '70/140/20',
            '70/150/20',
            '70/160/20',
            '70/170/20',
            '70/180/20',
            '70/190/20',
            '75/140/20',
            '75/150/20',
            '75/160/20',
            '75/170/20',
            '75/180/20',
            '75/190/20',
            '82/180/20',
            '82/190/20',
            '82/200/20',
            '82/200/30',
            '90/190/20',
            '90/190/30',
            '90/200/20',
            '90/200/30'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Благодарение на този богат избор можете лесно да намерите подходящ чаршаф с ластик за
          бебешко легло, детско легло или детски матрак.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          За пълен комплект спално бельо можете да комбинирате чаршафа с{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/detsko-spalno-belio/detski-plikove/2/10"
            sx={seoLinkStyle}>
            детски пликове за завивки
          </Typography>{' '}
          и{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/detsko-spalno-belio/detski-kalufki/2/8"
            sx={seoLinkStyle}>
            детски калъфки за възглавници
          </Typography>
        </Typography>

        {/* H2: Перфектно прилягане към матрака */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2, mt: 4 }}>
          Перфектно прилягане към матрака
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ластикът е поставен по целия ръб на чаршафа, което позволява той да обхване плътно матрака
          и да остане стабилен по време на сън. Това предотвратява набръчкване на плата и осигурява
          комфортна повърхност за спане.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Чаршафите са подходящи за матраци с височина до 20 см и до 30 см, което позволява добро
          прилягане към различни детски матраци.
        </Typography>

        {/* H2: Какъв плат да изберете? */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Какъв плат да изберете?
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Чаршафите с ластик се изработват от висококачествени памучни материи ранфорс и памучен
          сатен, които са подходящи за детско спално бельо.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Ранфорс
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ранфорсът е плътен и издръжлив памучен плат, подходящ за ежедневна употреба.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Можете да разгледате нашите{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-charshafi-s-lastik/2/9/2"
            sx={seoLinkStyle}>
            детски чаршафи с ластик ранфорс
          </Typography>
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1, mt: 2 }}>
          Памучен сатен
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Памучният сатен е по-гладка и фина материя с мек допир и лек естествен блясък.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ако предпочитате по-фина материя, можете да изберете{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-charshafi-s-lastik/2/9/1"
            sx={seoLinkStyle}>
            детски чаршафи с ластик памучен сатен
          </Typography>
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          И двата вида плат са 100% памук, дишащи и комфортни за сън.
        </Typography>

        {/* H2: Предимства на нашите детски чаршафи с ластик */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2, mt: 4 }}>
          Предимства на нашите детски чаршафи с ластик
        </Typography>
        <Box component="ul" sx={{ mb: 4, pl: 4, color: 'text.secondary' }}>
          <li>&#10004; изработени от 100% памук</li>
          <li>&#10004; подходящи за бебешка и детска кожа</li>
          <li>&#10004; ластик по целия ръб за стабилно фиксиране</li>
          <li>&#10004; голям избор от размери</li>
          <li>&#10004; дишащи и комфортни материи</li>
          <li>&#10004; устойчиви при многократно пране</li>
          <li>&#10004; произведени в България</li>
          <li>&#10004; платове със сертификат OEKO-TEX Standard 100</li>
        </Box>

        {/* H2: Свиваемост на памучния плат */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Свиваемост на памучния плат
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Тъй като чаршафите са изработени от 100% памук, е възможна естествена свиваемост около
          4–5% след първите пранета. Това е нормално свойство на памучните материи.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          При изработката на нашите чаршафи тази естествена свиваемост е предварително предвидена,
          така че след пране чаршафът да запази удобния си размер и да приляга добре към матрака.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Затова при избор на размер не е необходимо да добавяте допълнителни сантиметри – просто
          изберете размер според реалните размери на матрака.
        </Typography>

        {/* H2: Популярни размери детски чаршафи с ластик */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Популярни размери детски чаршафи с ластик
        </Typography>
        <Box component="ul" sx={{ mb: 4, pl: 4, color: 'text.secondary' }}>
          <li>чаршаф с ластик 60/120/20 (60х120х20) см</li>
          <li>чаршаф с ластик 70/140/20 (70х140х20) см</li>
          <li>чаршаф с ластик 70/160/20 (70х160х20) см</li>
          <li>чаршаф с ластик 90/200/30 (90х200х30) см</li>
        </Box>

        {/* H2: Срок за изработка */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Срок за изработка
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Всички детски чаршафи с ластик се изработват индивидуално след направена поръчка, според
          избрания размер на матрака.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Срокът за изработка е между 3 и 10 работни дни, като в повечето случаи поръчките са готови
          в рамките на 4–7 работни дни.
        </Typography>

        {/* H2: Детско спално бельо от 100% памук */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Детско спално бельо от 100% памук
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ако търсите качествено детско спално бельо от 100% памук, можете да разгледате и
          останалите продукти в нашия магазин. Предлагаме разнообразие от{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/detsko-spalno-belio/detski-plikove/2/10"
            sx={seoLinkStyle}>
            детски пликове за завивки
          </Typography>
          ,{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/detsko-spalno-belio/detski-charshafi/2/7"
            sx={seoLinkStyle}>
            детски чаршафи
          </Typography>
          ,{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/detsko-spalno-belio/detski-kalufki/2/8"
            sx={seoLinkStyle}>
            детски калъфки за възглавници
          </Typography>
          , изработени от висококачествени памучни материи като ранфорс и памучен сатен.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Всички продукти се изработват в България от платове със сертификат OEKO-TEX Standard 100,
          което гарантира безопасност и комфорт за бебешката и детската кожа.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за детски чаршафи с ластик
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилния размер детски чаршаф с ластик?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            За да изберете подходящ чаршаф с ластик, измерете ширината, дължината и височината на
            матрака. След това изберете чаршаф със същите размери.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да измерите матрак за чаршаф с ластик?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
            За да изберете подходящ чаршаф с ластик за детско легло, е важно да измерите правилно
            матрака.
          </Typography>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary', fontWeight: 600 }}>
            1. Измерете ширината на матрака
          </Typography>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Най-често срещаните размери при бебешките и детските легла са:
          </Typography>
          <Box component="ul" sx={{ mb: 2, pl: 4, color: 'text.secondary' }}>
            <li>60 см</li>
            <li>65 см</li>
            <li>70 см</li>
            <li>75 см</li>
            <li>82 см</li>
            <li>90 см</li>
          </Box>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary', fontWeight: 600 }}>
            2. Измерете дължината на матрака
          </Typography>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Често срещани дължини на детски матраци са:
          </Typography>
          <Box component="ul" sx={{ mb: 2, pl: 4, color: 'text.secondary' }}>
            <li>110 см</li>
            <li>120 см</li>
            <li>130 см</li>
            <li>140 см</li>
            <li>150 см</li>
            <li>160 см</li>
            <li>170 см</li>
            <li>180 см</li>
            <li>190 см</li>
            <li>200 см</li>
          </Box>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary', fontWeight: 600 }}>
            3. Измерете височината на матрака
          </Typography>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Височината се измерва от основата до горната повърхност на матрака.
          </Typography>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Предлагаме детски чаршафи с ластик за матраци с височина:
          </Typography>
          <Box component="ul" sx={{ pl: 4, color: 'text.secondary' }}>
            <li>до 20 см</li>
            <li>до 30 см</li>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са чаршафите с ластик за бебешко легло?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Чаршафите с ластик са много удобни за бебешки и детски легла, защото прилепват
            плътно към матрака и не се разместват по време на сън.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свиват ли се памучните чаршафи с ластик след пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Както всички изделия от 100% памук, и памучните чаршафи могат да имат естествена
            свиваемост около 4–5% след първите пранета. Това е нормално свойство на памучните
            материи като ранфорс и памучен сатен.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какъв плат е по-подходящ за детски чаршаф?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Най-популярните материи са ранфорс и памучен сатен. Ранфорсът е по-лек и устойчив, а
            памучният сатен е по-гладък и фин на допир.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват детските чаршафи?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички чаршафи се изработват в България, специално за всяка поръчка и според избрания
            размер.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
